import { createCategoryDependencies } from './categoryPermissionDependencies';

/**
 * Aplica as dependências do Admin ao alternar uma permissão da categoria.
 *
 * Marcar qualquer uma das três permissões (Navegar como, Filiais ou Permissões)
 * marca automaticamente o "Acesso ao Admin". De forma simétrica, desmarcar o
 * "Acesso ao Admin" remove as três permissões que dependem dele.
 */
export const applyAdminDependencies = createCategoryDependencies({
  categoryName: 'Admin',
  basePermissionKeys: ['read:Admin'],
  basePermissionDescriptions: ['Acesso ao Admin'],
  dependentPermissionKeys: [
    'managePermissions:Admin',
    'manageBranches:Admin',
    'impersonateUser:Admin',
  ],
  dependentPermissionDescriptions: ['Permissões', 'Filiais', 'Navegar como'],
});

export function useAdminRowPermissions() {
  return {
    applyAdminDependencies,
  };
}
